import type { Optional } from '@festina-life/core'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import {
  DEFAULT_PERCENT_DECIMAL_SCALE,
  formatPercentage,
} from '../forms/percentageInput/percentageInput.utils'

export const usePercentageFormatter = () => {
  const { locale } = useIntl()
  const formatPercent = useCallback(
    (value: Optional<number | string>) =>
      formatPercentage({ value, decimals: 0, locale }),
    [locale],
  )

  const formatPercentWithDecimals = useCallback(
    (value: Optional<number | string>, decimals?: number) =>
      formatPercentage({
        value,
        decimals: decimals ?? (value !== 0 ? DEFAULT_PERCENT_DECIMAL_SCALE : 0),
        locale,
      }),
    [locale],
  )

  return {
    formatPercent,
    formatPercentWithDecimals,
  }
}
